<footer>
  <div class="footer-section">
    <div class="row font-13">
      <div class="col-md-6 footer_copy">2018 - {{currentyear}} © <b>ZERO BrandCard™</b> - Connect Possibilities</div>
      <div class="col-md-6 footer_links">
        <a routerLink="/contact" target="_blank"><span>Contact Us</span></a>
        <a routerLink="/terms" target="_blank"><span>Terms & Conditions</span></a>
        <a routerLink="/privacy" target="_blank"><span>Privacy Policy</span></a>
      </div>
    </div>
  </div>
</footer>
